import { ISMT_NhomDeThiIn_Request } from "../../../../model/request/de-thi/de-thi-in/ISMT_NhomDeThiIn_Request";
import { ISMT_NhomDeThiIn } from "../../../../model/respone/de-thi/ISMT_NhomDeThiIn";
import { generateActionTypeIds } from "../../generateActionTypeIds";
import IGenericActionType from "../../IGenericActionType";

export const eNhomDeThiInActionsObj = {
  LOAD_START: {} as ISMT_NhomDeThiIn_Request,
  LOAD_SUCCESS: {} as ISMT_NhomDeThiIn[],
  LOAD_ERRR: "",

  SAVE_START: {} as ISMT_NhomDeThiIn,
  SAVE_SUCCESS: {} as ISMT_NhomDeThiIn,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SELECTED_ID: [] as number[],

  SHOW_EDIT_MODAL: {} as undefined | ISMT_NhomDeThiIn,
  CLOSE_EDIT_MODAL: undefined,

  SHOW_VIEW_DOICAUHOI_MODAL: {} as ISMT_NhomDeThiIn,
  CLOSE_VIEW_DOICAUHOI_MODAL: undefined,

  CHANGE_REQUEST: {} as any,

  SHOW_PROGRESS_MODAL: {} as number[],
  CLOSE_PROGRESS_MODAL: undefined,

  DELETE_MULTIPLE_START: {} as number[],
  DELETE_MULTIPLE_SUCCESS: undefined,
  DELETE_MULTIPLE_ERROR: "",
};
export const eNhomDeThiInActionIds = generateActionTypeIds(
  eNhomDeThiInActionsObj,
  "NHOM_DE_THI_IN"
);
export type INhomDeThiInActionTypes = IGenericActionType<
  typeof eNhomDeThiInActionsObj,
  "NHOM_DE_THI_IN"
>;
